function Nav() {
  return (
    <nav className="navbar">
      <div className="brand">
        <img src="./assets/profile.jpg" alt="Muhammad Ali" />
        <div>
          <p className="name">Muhammad Ali</p>
          <span>Frontend Engineer · Creative Technologist</span>
        </div>
      </div>

      <div className="nav-links">
        <a href="#projects">Projects</a>
        <a href="#stack">Stack</a>
      </div>

      <a
        className="btn"
        href="https://alishah151.github.io/cv/"
        target="_blank"
        rel="noreferrer"
      >
        View Resume
      </a>
    </nav>
  );
}

export default Nav;
